import React, {Suspense, useEffect, useState} from "react";
import styled from "@emotion/styled";
import {AnimatePresence} from "framer-motion";
import {Route, Routes, useLocation, useNavigate} from "react-router-dom";

import {routes} from "../common/constants/common";
import {alert_show_state, loading_state, notify_show_state, useAlert,} from "../common/atom/dialog";
import {useRecoilValue, useSetRecoilState} from "recoil";
import Alert from "./components/Alert";
import Spinner from "./components/Spinner";
import Notification from "./components/Notification";
import {token_state} from "../common/atom/session";
import {sendApp} from "../common/util/utils";

const Home = React.lazy(() => import("./pages/Home"));
const SMSRequest = React.lazy(() => import("./pages/sms/SMSRequest"));
const SMSConfirm = React.lazy(() => import("./pages/sms/SMSConfirm"));
const AcntRequest = React.lazy(() => import("./pages/acnt/AcntRequest"));
const AcntConfirm = React.lazy(() => import("./pages/acnt/AcntConfirm"));



const Dim = styled.div`
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Container = styled.div`
    width: 100%;
    height: 100%;
    max-width: 430px;

    /** PC 화면 설정 */
    @media (min-width: 431px) {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    /** iOS safe-area 설정 */
    @supports (env(safe-area-inset-top)) {
        padding: env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);
    }
`;

let initialHeight: number;
export default function App() {
    const navigate = useNavigate();
    const location = useLocation();
    const alert = useAlert();

    const [isKeyboardOpen, setKeyboardOpen] = useState(false);
    const isNotify = useRecoilValue(notify_show_state);
    const isAlert = useRecoilValue(alert_show_state);
    const isLoading = useRecoilValue(loading_state);
    const setToken = useSetRecoilState(token_state);

    useEffect(() => {
        const approveToken = new URLSearchParams(location.search).get("approveToken");
        const withdrawToken = new URLSearchParams(location.search).get("withdrawToken");
        initialHeight = window.innerHeight;

        if (!approveToken && !withdrawToken) {
            sendApp("failure", {code: "9999", message: "'token' 이 없습니다."});
            return;
        }

        let mode = "";
        if (approveToken) {
            setToken(approveToken);
            mode = "approve";
        }

        if (withdrawToken) {
            setToken(withdrawToken);
            mode = "withdraw";
        }

        navigate(routes.sms.request, {state: {mode}});
    }, []);

    window.onresize = (e) => {
        setKeyboardOpen(initialHeight > window.innerHeight + 100)
    }

    window.goBack = () => {
        switch (location.pathname) {
            case "/":
            case routes.sms.request:
                sendApp("cancel");
                break;
            case routes.acnt.request:
                alert("회원가입을 취소하시겠습니까?", "", () => sendApp("cancel"));
                break;
            default:
                navigate(-1);
        }
    }

    return (
        <Dim>
            <Container className={isKeyboardOpen ? "keyboard-open" : ""}>
                {isNotify && <Notification/>}
                {isAlert && <Alert/>}
                {isLoading && <Spinner/>}
                <AnimatePresence>
                    <Suspense fallback={<div></div>}>
                        <Routes>
                            <Route path={"/"} element={<Home/>}/>
                            <Route path={routes.sms.request} element={<SMSRequest/>}/>
                            <Route path={routes.sms.confirm} element={<SMSConfirm/>}/>
                            <Route path={routes.acnt.request} element={<AcntRequest/>}/>
                            <Route path={routes.acnt.confirm} element={<AcntConfirm/>}/>
                        </Routes>
                    </Suspense>
                </AnimatePresence>
            </Container>
        </Dim>
    );
}
